export * from './form-base.container';

import {
  AuthCallbackComponent,
  UnauthorizedComponent,
} from './unauthorized.container';

export const AUTH_COMPONETNS = [AuthCallbackComponent, UnauthorizedComponent];
export { AuthCallbackComponent, UnauthorizedComponent };
